import React from 'react'
import PropTypes from 'prop-types'
import staticFilesUrl from 'utils/staticFilesUrl'

const Illustration = ({ image, maxWidth = 280, baseUrl = '' }) => (
  <img
    style={{ maxWidth }}
    aria-hidden
    alt=""
    src={`${baseUrl}${staticFilesUrl}assets/images/${image}.png`}
    srcSet={
      `${baseUrl}${staticFilesUrl}assets/images/${image}@2x.png 2x, ` +
      `${baseUrl}${staticFilesUrl}assets/images/${image}@3x.png 3x`
    }
  />
)

export default Illustration

Illustration.propTypes = {
  image: PropTypes.string,
  maxWidth: PropTypes.number,
  baseUrl: PropTypes.string,
}
